import { Component } from 'react';
import { Row, Col, Badge, Calendar, DatePicker, message, Tooltip, Typography } from "antd";
import { ReModal } from "@/components/refineElement";
import { showDelConfirm, getOnOkFunction } from "@/lib/antdElementFunction";
import {
  startThisMonth,
  endThisMonth,
  convertToTimestamp,
  dateFormat,
  startTimeToday,
  convertToTimestamp10,
  getDateCellDataArray,
  disabledMonth,
  getMoment,
  dateTimeFormat5,
} from "@/lib/dateTime";
import Place from "@/config/place";
import { getLangList } from '@/lib/i18n';
import { hasPermission } from "@/lib/permissionUtil";
import ModalInfo from "./modalInfo";
import "./index.less";

const { getPlaceInfo, createPlaceInfo, updatePlaceInfo, deletePlaceInfo } = Place;
const placeColorObject: any = {
  threeLobby: 'orange',
  library: 'green',
  performanceHall: 'pink',
}

interface state {
  isModalVisible: boolean;
  handleType: string;
  selectedDate: any;
  startTime: any;
  endTime: any;
  dataArray: Array<object>;
  placeInfo: any;
}

class RentOutField extends Component<{}, state> {
  state = {
    isModalVisible: false,
    handleType: '',
    selectedDate: startTimeToday,
    startTime: startThisMonth,
    endTime: endThisMonth,
    dataArray: [],
    placeInfo: {} as never as any,
  };
  rentOutFieldT: any = getLangList("rentOutField");
  errorT: any = getLangList("error");
  errorCodeT: any = getLangList("errorCode");
  isClickDate: boolean = true;

  componentDidMount() {
    this.getPlaceInfo();
  }

  getPlaceInfo = () => {
    const { startTime, endTime } = this.state;
    const params = { startTime: convertToTimestamp(startTime), endTime: convertToTimestamp(endTime) };

    getPlaceInfo(params).then((res: any) => {
      const dataArray = res?.value ?? {};
      this.setState({ dataArray });
    });
  }

  toggleModal = (handleType: string = '') => {
    const { isModalVisible } = this.state;
    this.setState({ isModalVisible: !isModalVisible, handleType });
  };

  dateCellRender = (date: any) => {
    const { dataArray } = this.state;
    const listData = getDateCellDataArray(date, dataArray);

    return (
      <ul className="rent-out-events">
        {listData.map((item: any, idx: any) => {
          const { placeName, className } = item;

          return (
            <li key={idx}>
              <Tooltip title={className}>
                <div className={`rent-out-div`} onClick={this.clickEdit(item)}>
                  <Badge color={placeColorObject[placeName]} text={className} />
                </div>
              </Tooltip>
            </li>
          );
        })}
      </ul>
    );
  };

  changeMonth = (value: any, onChange: any) => {
    const startTime = convertToTimestamp(value.startOf("month"));
    const endTime = convertToTimestamp(value.endOf("month"));

    this.isClickDate = false;
    onChange(value);
    this.isClickDate = true;
    this.setState({ startTime, endTime }, this.getPlaceInfo);
  }

  clickCreate = (value: any) => {
    if (!hasPermission('RENT_OUT_FIELD_NEW')) {
      return;
    }
    this.isClickDate && this.setState({ placeInfo: {}, selectedDate: value.format(dateFormat) }, () => this.toggleModal('create'));
  }

  clickEdit = (item: any) => (e: any) => {
    e.stopPropagation();
    this.setState({ placeInfo: item }, () => this.toggleModal('update'));
  }

  clickDelete = () => {
    const { placeInfo } = this.state;
    const { id } = placeInfo;
    showDelConfirm(() => this.deletePlaceInfo(id));
  };

  createPlaceInfo = (values: any) => {
    const { placeName, classId, description, date, semesterId } = values;
    const params = {
      placeName,
      classId,
      description,
      startTime: convertToTimestamp10(date[0]),
      endTime: convertToTimestamp10(date[1]),
      semesterId,
    };

    createPlaceInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorCodeT[res.errorCode] ?? this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      this.getPlaceInfo();
    });
  }

  updatePlaceInfo = (values: any) => {
    const { placeInfo } = this.state;
    const { id } = placeInfo;
    const { date, placeName, classId, description, semesterId } = values;
    const params = {
      startTime: convertToTimestamp10(date[0]),
      endTime: convertToTimestamp10(date[1]),
      placeName,
      classId,
      description,
      id,
      semesterId,
    };

    if (!hasPermission('RENT_OUT_FIELD_EDIT')) {
      return message.error(this.errorT.NO_PERMISSION);
    }

    updatePlaceInfo(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorCodeT[res.errorCode] ?? this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      this.getPlaceInfo();
    });
  }

  deletePlaceInfo = (id: string) => {
    deletePlaceInfo(id).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.toggleModal();
      this.getPlaceInfo();
    });
  }

  render() {
    const { isModalVisible, selectedDate, handleType, placeInfo, startTime } = this.state;
    const okFunction = {
      create: this.createPlaceInfo,
      update: this.updatePlaceInfo,
    };

    return (
      <>
        <Row gutter={[8, 0]} justify="center" className="rent-out-search-bar">
          <Col>
            <Typography.Title level={3}>
              {getMoment(startTime).format(dateTimeFormat5)}
            </Typography.Title>
          </Col>

          <Col span={24}>
            <div className="rent-out-type-example-container">
              <div className="rent-out-type-example">
                <div className="rent-out-type-example-color threeLobby" />
                <div className="rent-out-type-example-text">{this.rentOutFieldT.THREE_LOBBY}</div>
              </div>
              <div className="rent-out-type-example">
                <div className="rent-out-type-example-color library" />
                <div className="rent-out-type-example-text">{this.rentOutFieldT.LIBRARY}</div>
              </div>
              <div className="rent-out-type-example">
                <div className="rent-out-type-example-color performanceHall" />
                <div className="rent-out-type-example-text">{this.rentOutFieldT.PERFORMANCE_HALL}</div>
              </div>
            </div>
          </Col>
        </Row>

        <Row gutter={[8, 0]} justify="center">
          <Col span={22}>
            <Calendar
              dateCellRender={this.dateCellRender}
              onSelect={this.clickCreate}
              headerRender={({ value, type, onChange, onTypeChange }) =>
                <Row justify="end">
                  <Col>
                    <DatePicker
                      picker="month"
                      allowClear={false}
                      disabledDate={disabledMonth(0, 11)}
                      defaultValue={startThisMonth}
                      onChange={(month) => this.changeMonth(month, onChange)}
                    />
                  </Col>
                </Row>
              }
            />
          </Col>
        </Row>

        {isModalVisible &&
          <ReModal
            title={this.rentOutFieldT.RENT_PLACE}
            onCancel={() => this.toggleModal()}
            visible={isModalVisible}
            onOk={(data: any) => getOnOkFunction(handleType, data, okFunction)}
            CollectedForm={ModalInfo}
            formProps={{
              selectedDate,
              placeInfo,
              handleType,
              clickDelete: this.clickDelete,
            }}
          />
        }
      </>
    );
  }
}

export default RentOutField;